import { createSelector } from '@ngrx/store';

import { getSelectedCycle } from './cycle.selectors';

export const getCosts = createSelector(getSelectedCycle, (cycle) =>
  cycle ? cycle.costs : undefined,
);
